import { createSelector } from '@ngrx/store';
import { PaxState } from '@pax/store/state/pax.state';
import { paxRootSelector } from '@pax/store/selectors/pax-root.selector';

export const selectPaxLoading = createSelector(
  paxRootSelector,
  (state: PaxState) => state.travelers.isLoadingTravelerForm
);
